module.exports = __webpack_public_path__ + "static/media/yatra-booking-data-format.754efe33.xlsx";